var render, staticRenderFns
import script from "./resize-sensor.vue?vue&type=script&lang=js&"
export * from "./resize-sensor.vue?vue&type=script&lang=js&"
import style0 from "./resize-sensor.vue?vue&type=style&index=0&id=38cddd49&prod&lang=css&"


/* normalize component */
import normalizer from "!../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports